import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../shared/shared.module';
import { FishMapComponent } from './fish-map.component';
import { DateFormatPipe } from '../core/pipes/date-format.pipe';
import { WeightFormatPipe } from '../core/pipes/weight-format.pipe';
import { RecapturesListComponent } from './recaptures-list/recaptures-list.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    SharedModule
  ],
  exports: [
    FishMapComponent
  ],
  declarations: [
    DateFormatPipe,
    WeightFormatPipe,
    FishMapComponent,
    RecapturesListComponent
  ]
})
export class FishMapModule { }
